export type CardGridColumns = 2 | 3 | 4;

export type CardGridCardStyle = "link" | "text";

export type CardGridCard = {
  id: number;
  order: number;
  title: string;
  href: string;
  text: string;
  subTitle?: string;
  badge?: string;
  image?: string;
  imageAlt?: string;
};

export type CardGridContent = {
  heading: string;
  intro: string;
  cards: CardGridCard[];
  background: BlockBackground;
  columns?: CardGridColumns;
  cardStyle?: CardGridCardStyle;
};

export type CardModalGridCard = {
  id: number;
  order: number;
  heading: string;
  subheading: string;
  image: string;
  description: string;
  socialLink?: string;
};

export type CardModalGridContent = {
  cards: CardModalGridCard[];
};

export type IframeContent = {
  heading: string;
  intro: string;
  src: string;
  title: string;
  background: BlockBackground;
};

export type AddressGridAddress = {
  city: string;
  lines?: string[];
  order?: number;
};

export type AddressGridContent = {
  addresses: AddressGridAddress[];
};

export const BLOCK_BACKGROUNDS = ["default", "muted", "blue", "dark", "brand"] as const;

export type BlockBackground = (typeof BLOCK_BACKGROUNDS)[number];

export type HeroLink = {
  label: string;
  href: string;
};

export type HeroContent = {
  title: string;
  imageUrl: string;
  imageAlt: string;
  links: HeroLink[];
  background: BlockBackground;
};

export type TextContent = {
  heading: string;
  body: string;
  background: BlockBackground;
  anchorId?: string;
};

export type StatsItem = {
  value: string;
  label: string;
  tooltip: string;
};

export type StatsContent = {
  heading: string;
  stats: StatsItem[];
  background: BlockBackground;
};

export type PeoplePerson = {
  name: string;
  role: string;
  email: string;
  imageUrl: string;
};

export type PeopleContent = {
  heading: string;
  intro: string;
  people: PeoplePerson[];
  background: BlockBackground;
};

export type IconListItem = {
  iconUrl: string;
  heading: string;
  text: string;
};

export type IconListContent = {
  heading: string;
  intro: string;
  items: IconListItem[];
  background: BlockBackground;
};

export type ButtonVariant = "primary" | "secondary";

export type ButtonsButton = {
  label: string;
  href: string;
  variant: ButtonVariant;
};

export type ButtonsContent = {
  buttons: ButtonsButton[];
  background: BlockBackground;
};

export type GalleryImage = {
  url: string;
  alt: string;
  caption: string;
};

export type GalleryContent = {
  heading: string;
  intro: string;
  images: GalleryImage[];
  background: BlockBackground;
};

export type BlockButton = ButtonsButton;

export type SectionContent = {
  heading?: string;
  background?: BlockBackground;
  anchorId?: string;
};

export type BannerContent = SectionContent & {
  title: string;
  tagline: string;
  primaryButton?: BlockButton;
  secondaryButton?: BlockButton;
  videoUrl?: string;
  poster?: string;
};

export type StepsItem = {
  id: number;
  order: number;
  heading?: string;
  text: string;
  image?: string;
  imageAlt?: string;
};

export type StepsContent = SectionContent & {
  intro?: string;
  items: StepsItem[];
};

export type VideoContent = SectionContent & {
  intro?: string;
  url: string;
  title: string;
  caption?: string;
  poster?: string;
};

export type AccordionItem = {
  id: number;
  order: number;
  question: string;
  answer: string;
};

export type AccordionContent = SectionContent & {
  items: AccordionItem[];
};

export type CallToActionContent = SectionContent & {
  text?: string;
  buttons: BlockButton[];
};

export type BlockContentErrors = Record<string, string>;
